import { ApiResponse } from "../interfaces/Api";
import { Training } from "../interfaces/TrainingInterface";
import { Get, Post, Patch, Delete } from "./apiHelper";

const trainingsRoot = "/api/trainings";

export interface GetTrainingsParams {
  clientId?: number;
  resourceCentreId?: number;
  certificateNumber?: string;
  search?: string;
  page?: number;
  limit?: number;
}

export const getTrainings = async (
  params: GetTrainingsParams = {}
): Promise<ApiResponse<Array<Training>>> => {
  const query = new URLSearchParams();

  if (params.clientId) query.append("clientId", params.clientId.toString());
  if (params.resourceCentreId) query.append("resourceCentreId", params.resourceCentreId.toString());
  if (params.certificateNumber) query.append("certificateNumber", params.certificateNumber);
  if (params.search) query.append("search", params.search);
  if (params.page) query.append("page", params.page.toString());
  if (params.limit) query.append("limit", params.limit.toString());

  const result = await Get(`${trainingsRoot}?${query.toString()}`, true);
  return result.data as ApiResponse<Array<Training>>;
};

export async function getTrainingById(id: number | string): Promise<ApiResponse<Training>> {
  const result = await Get(`${trainingsRoot}/${id}`, true);
  return result.data as ApiResponse<Training>;
}

export async function postTraining(data: Partial<Training>): Promise<ApiResponse<Training>> {
  const response = await Post(`${trainingsRoot}`, data, true);
  return response.data as ApiResponse<Training>;
}

export async function patchTraining({
  id,
  data
}: {
  id: number | string;
  data: Partial<Training>;
}): Promise<ApiResponse<Training>> {
  const response = await Patch(
    `${trainingsRoot}/${id}`,
    data as unknown as Record<string, unknown>,
    true
  );
  return response.data as ApiResponse<Training>;
}

export async function deleteTraining(id: number | string): Promise<ApiResponse<null>> {
  const response = await Delete(`${trainingsRoot}/${id}`, true);
  return response.data as ApiResponse<null>;
}
